var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronBas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.331755 0.29558C0.558457 0.0521361 0.945304 0.0333894 1.1958 0.253709L9.67358 7.71015L18.1514 0.253709C18.4019 0.0333894 18.7887 0.0521361 19.0154 0.29558C19.2421 0.539025 19.2228 0.914979 18.9723 1.1353L10.0914 8.94627C9.97236 9.05101 9.82245 9.10172 9.67359 9.09995C9.52472 9.10173 9.37481 9.05102 9.25572 8.94627L0.37484 1.1353C0.124343 0.914979 0.105053 0.539025 0.331755 0.29558Z",
    fill: "#095797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBas);
export default __webpack_public_path__ + "static/media/chevron-bas.d3cadfd40ea516b3ee452e17218b095f.svg";
export { ForwardRef as ReactComponent };